import { useState } from 'react';
import useFormValidation from '../../../../../hooks/useFormValidation';
import useResponsiblesFieldsConfig from './useResponsiblesFieldConfig';
import { useTranslation } from 'react-i18next';
import useTranslate from '../../../../../hooks/useTranslate';

export interface IResponsiblesForm {
    id: string;
    cuit: string;
    responsibleName: string;
    responsibleSurname: string;
    permission: string;
    professionalLicense: string;
    expeditionDate: string;
    expirationDate: string;
    responsibleType: string;
    individualAuthorization?: string;
    specialLicense?: null | { id: number; value: boolean; nombre: string };
    habilitationAddress?: string;
    professionalDegree?: string;
}

export const initialResponsiblesForm: IResponsiblesForm = {
    id: '',
    cuit: '',
    responsibleName: '',
    responsibleSurname: '',
    permission: '',
    professionalLicense: '',
    expeditionDate: '',
    expirationDate: '',
    responsibleType: '',
    individualAuthorization: '',
    specialLicense: null,
    habilitationAddress: '',
    professionalDegree: ''
};

export interface ResponsiblesFormProps {
    selectedCarcinogenicReportId: number | null;
    selectedRadiologicalEquipment?: IResponsiblesForm;
    isEditing: boolean;
    handleCloseDrawer: any;
}

interface GetInitialData {
    selectedRadiologicalEquipment: any;
    isEditing: boolean;
}

export const useResponsiblesForm = ({
    selectedCarcinogenicReportId,
    selectedRadiologicalEquipment,
    isEditing,
    handleCloseDrawer
}: ResponsiblesFormProps) => {
    const [formData, setFormData] = useState<IResponsiblesForm>(initialResponsiblesForm);
    const { t } = useTranslation('carcinogenicReport', {
        keyPrefix: 'modules.radiologicalEquipment'
    });

    const {translate} = useTranslate(t);
    const {
        errors,
        hasValidationErrors,
        validateForm,
        handleBlurValidation,
        resetValidation,
        setErrors
    } = useFormValidation();

    const { responsiblesFieldsConfig } = useResponsiblesFieldsConfig({
        t,
        formData,
        handleBlurValidation
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        if (!validateForm(formData, responsiblesFieldsConfig)) return;
    };

    const resetForm = () => {
        setFormData(initialResponsiblesForm);
    };

    return {
        formData,
        errors,
        responsiblesFieldsConfig,
        translate,
        resetForm,
        handleChange,
        validateForm,
        handleSubmit
    };
};